import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=5cb559c0&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"
import style0 from "./CtaSection.vue?vue&type=style&index=0&id=5cb559c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb559c0",
  null
  
)

export default component.exports